<div class="app-container bg-dib-gray-100">
  <router-outlet></router-outlet>
</div>
